import React from 'react';
import { ContentTabToggle } from './ui/content-tab-toggle';
import { WelcomeMessagesSection } from './interview-messages/WelcomeMessagesSection';
import { CompletionMessagesSection } from './interview-messages/CompletionMessagesSection';
import { CompanyQuestionsSection } from './interview-messages/CompanyQuestionsSection';
import { TestMessageSection } from './interview-messages/TestMessageSection';
import { useAuthStore } from '../store/authStore';

type ProcessTab = 'welcome' | 'test' | 'completion' | 'company';

export const InterviewProcessPage: React.FC = () => {
  const { role, user } = useAuthStore();
  const isSuperAdmin = String((user as any)?.role || role || '').toUpperCase() === 'SUPER_ADMIN';
  
  // По умолчанию показываем "Вопросы о компании" для всех пользователей
  const [activeTab, setActiveTab] = React.useState<ProcessTab>('company');

  return (
    <div className="bg-[#f5f6f1] relative rounded-[24px] shrink-0 w-full h-full overflow-hidden">
      <div className="flex flex-col items-start relative size-full">
        <div className="box-border content-stretch flex flex-col gap-4 items-start justify-start p-5 relative w-full h-full overflow-hidden">
          {/* Заголовок страницы */}
          <div className="box-border content-stretch flex flex-row gap-2.5 items-center justify-start px-0 py-0 relative shrink-0">
            <div className="css-sqkidj font-['Inter_Display:Medium',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#000000] text-[24px] text-left text-nowrap">
              <p className="block leading-[30px] whitespace-pre">Процесс интервью</p>
            </div>
          </div>

          <ContentTabToggle
            options={[
              // Табы доступны только суперадминам
              ...(isSuperAdmin ? [
                { id: 'welcome', label: 'Вступление' },
                { id: 'test', label: 'Тест микрофона' },
                { id: 'completion', label: 'Завершение' },
              ] : []),
              // Таб "Вопросы о компании" доступен всем
              { id: 'company', label: 'Вопросы о компании' },
            ]}
            activeTab={activeTab}
            onTabChange={(tab) => setActiveTab(tab as ProcessTab)}
          />

          <div className="w-full flex-1 overflow-y-auto">
            {activeTab === 'welcome' && isSuperAdmin && (
              <WelcomeMessagesSection embedded />
            )}
            {activeTab === 'test' && isSuperAdmin && (
              <TestMessageSection embedded />
            )}
            {activeTab === 'completion' && isSuperAdmin && (
              <CompletionMessagesSection embedded />
            )}
            {activeTab === 'company' && (
              <CompanyQuestionsSection embedded />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


